import {observable} from 'mobx';
import {OfferAssetType} from './offer-asset-type';
import {construct, createInstance, ModelProperties} from '../utils';

export class OfferAsset {
    @observable id!: number;

    @observable filename!: string;

    @observable baseUrl!: string;

    @observable enabled!: boolean;

    @observable pathname!: string;

    @observable pathnameWebp?: string;

    @observable typeId!: number;

    @observable type?: OfferAssetType;

    @observable tags: string[] = [];

    constructor(asset?: ModelProperties<OfferAsset>) {
        if (asset) {
            construct(this, asset);
            this.type = createInstance(OfferAssetType, asset.type);
        }
    }
}
